import * as React from 'react';
import { observer } from "mobx-react";
import { Localize } from "shared/utils/localization";
import { PairingStore } from "./pairingstore";
import { CPairingDevice } from "./devices/pairingdevice";
import { BottomButtons, BottomButton } from './pairing';

@observer
export class PairingSelectDeviceComponent extends React.Component
{
	constructor( props: any )
	{
		super( props );
	}

	public render()
	{
		const rDevices = Array.from( PairingStore.getPairableDevices().values() );

		return <div>
			<div className="Title Label">{ Localize( '#pairing_selectdevice_title' ) }</div>
			<div className="PageContent PairingOptions">
				{ rDevices.map( ( value, index ) =>
					<div key={ index } className={ "PairingOption " + value.className }>
						<div className="Button" onClick={ () => PairingStore.selectPairingDevice( value ) } >{ value.renderControllerImage( false ) }</div>
						<div className="PairingOptionText Label">{ value.controllerName }</div>
					</div> ) }
			</div>
		</div>;
	}
}
